import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DialogModalSurveyService {
  private _modalShown = new BehaviorSubject<boolean>(this.getModalShownFromLocalStorage());

  modalShown$ = this._modalShown.asObservable();

  setModalShown(value: boolean): void {
    this._modalShown.next(value);
    localStorage.setItem('isModalShown', JSON.stringify(value));
  }

  private getModalShownFromLocalStorage(): boolean {
    return JSON.parse(localStorage.getItem('isModalShown')) || false;
  }
}